var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ComponentContext } from '../../Context/ComponentContext';
import { EventType, UsageEventName, } from '../../Models/UsageTelemetry';
// eslint-disable-next-line @typescript-eslint/ban-types
export function withButtonClickLogging(WrappedComponent) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name;
    function ComponentWithClickLogging(props) {
        const { aiEventName } = props, restProps = __rest(props, ["aiEventName"]);
        const { telemetryClient, telemetryContext } = React.useContext(ComponentContext);
        const handleClicked = React.useCallback((e) => {
            var _a;
            const buttonEvent = {
                type: EventType.User,
                eventName: UsageEventName.ButtonClicked,
                subFeature: props.usageEvent.subFeature,
                feature: props.usageEvent.feature,
                subFeatureLevel2: props.usageEvent.subFeatureLevel2,
                featureLocation: props.usageEvent.featureLocation,
            };
            telemetryClient.trackEvent(buttonEvent, Object.assign(Object.assign(Object.assign({}, telemetryContext), { aiEventName, buttonTitle: restProps.title, buttonText: restProps.text }), (((_a = props.logCustomProperties) === null || _a === void 0 ? void 0 : _a.call(props)) || {})));
            if (restProps.onClick)
                restProps.onClick(e);
        }, 
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [telemetryClient, telemetryContext, aiEventName, restProps]);
        const rest = restProps;
        return React.createElement(WrappedComponent, Object.assign({}, rest, { onClick: handleClicked }));
    }
    ComponentWithClickLogging.displayName = displayName;
    return ComponentWithClickLogging;
}
//# sourceMappingURL=withButtonClickLogging.js.map